import { z } from "zod"

export const ImportStatusEnum = z.enum(["QUEUED", "PROCESSING", "COMPLETED", "FAILED"])
export type ImportStatus = z.infer<typeof ImportStatusEnum>

export const ImportKindEnum = z.enum(["CUSTOMERS"])
export type ImportKind = z.infer<typeof ImportKindEnum>

export const CustomerImportFieldEnum = z.enum([
  "firstName",
  "lastName",
  "name",
  "email",
  "phone",
  "country",
  "language",
  "tags",
])
export type CustomerImportField = z.infer<typeof CustomerImportFieldEnum>

export const CustomerImportTargetEnum = z.enum([
  ...CustomerImportFieldEnum.options,
  "metadata",
  "ignore",
])
export type CustomerImportTarget = z.infer<typeof CustomerImportTargetEnum>
